import { MainLayout } from "../layouts/MainLayout_Old";

const DashboardPage = () => {
  return (
    <MainLayout>
      Dashboard
      <i className="he he-star"></i>
    </MainLayout>
  );
};

export { DashboardPage };
